class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.messageEl = document.getElementById('cart-notification-product');
    this.quantityEl = this.notification?.querySelector('.cart-toast__quantity');
    this.autoCloseTimeout = null;

    this.notification?.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);

    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = setTimeout(() => this.close(), 3500);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    clearTimeout(this.autoCloseTimeout);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const sections = this.getSectionsToRender();

    sections.forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;
      const selector = section.selector || '.shopify-section';
      if (section.id === 'cart-icon-bubble') {
        const el = document.getElementById(section.id);
        if (el) {
          el.innerHTML = this.getSectionInnerHTML(sectionHtml, selector);
        }
      }
    });

    let productName = '';
    let quantity = 1;
    const items = parsedState.items || [];
    const lastItem = items[items.length - 1];
    if (lastItem) {
      productName = lastItem.product_title || lastItem.title || '';
      quantity = lastItem.quantity != null ? lastItem.quantity : 1;
    }
    if (!productName && parsedState.sections?.['cart-notification-product']) {
      const doc = new DOMParser().parseFromString(parsedState.sections['cart-notification-product'], 'text/html');
      const names = doc.querySelectorAll('.cart-notification-product__name');
      if (names.length) {
        productName = names[names.length - 1].textContent.trim();
      }
    }

    if (this.messageEl && this.quantityEl) {
      this.messageEl.textContent = productName ? `${productName} added to cart!` : 'Item added to cart!';
      this.quantityEl.textContent = `Quantity: ${quantity}`;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
